import React, { useState } from 'react'
import './NotifyPatientStyle.css'
import { Form, Modal } from 'react-bootstrap'
import { Button } from '@components/common'
import MessagePreviewModal from '../MessagePreview/MessagePreview.component'
import moment from 'moment'
import { useAppSelector } from '@store/hooks'

type NotifyPatientProps = {
  show: boolean
  onHide: () => void
  data: any
  onNotify: (data: any, content: string) => void
}

enum NotifyPatientTemplate {
  appointment_reminder = 'Appointment reminder',
}

const NotifyPatient: React.FC<NotifyPatientProps> = ({
  show,
  onHide,
  data,
  onNotify,
}) => {
  const clinic = useAppSelector((state) => state.clinic.selectedClinic)
  const [template, setTemplate] = useState<NotifyPatientTemplate>(
    NotifyPatientTemplate.appointment_reminder,
  )
  const [showMessagePreview, setShowMessagePreview] = useState(false)
  const handleTemplateSelect = (value: string): void => {
    setTemplate(value as NotifyPatientTemplate)
  }
  const handlePreview = (): void => {
    setShowMessagePreview(true)
  }

  const getContentByTemplate = (): string => {
    switch (template) {
      case NotifyPatientTemplate.appointment_reminder:
        if (!data) return ''
        const patientName = `${data.patient.first_name} ${data.patient.last_name}`
        const appointmentDate = `${moment(data.date).format('YYYY-MM-DD')} at ${data.appt_start}`
        const clinicName = clinic?.clinic_name
        const clinicPhone = clinic?.phone_number
        return `Hi ${patientName}, this is ${clinicName} reminding you of your dental appointment ${appointmentDate}. Reply 'C' to confirm or call us at +${clinicPhone} to reschedule. See you soon!`
    }
  }
  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        centered
        className="notify-patient-modal"
      >
        <Modal.Body>
          <div>
            <h5>Notify patient</h5>
            <Form.Group>
              <Form.Label>Select template</Form.Label>
              <Form.Select
                value={template || ''}
                onChange={(e) => handleTemplateSelect(e.target.value)}
              >
                {Object.values(NotifyPatientTemplate).map((option) => (
                  <option key={option.toString()} value={option.toString()}>
                    {option.toString()}
                  </option>
                ))}
              </Form.Select>
              <Button
                size="md"
                className="button-secondary preview-button"
                onClick={handlePreview}
                type="button"
              >
                Preview
              </Button>
            </Form.Group>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button size="md" className="button-secondary" onClick={onHide}>
            Close
          </Button>
          <Button
            size="md"
            className="button-primary"
            onClick={() => onNotify(data, getContentByTemplate())}
          >
            Notify
          </Button>
        </Modal.Footer>
      </Modal>
      {showMessagePreview && (
        <MessagePreviewModal
          show={showMessagePreview}
          onHide={() => setShowMessagePreview(false)}
          content={getContentByTemplate()}
        />
      )}
    </>
  )
}

export default NotifyPatient
